// extracted by mini-css-extract-plugin
export default {"tabItem":"message_tabItem__Usz2F"};